import React from "react";
import EngineBrandCard from "../components/EngineBrandCard";

const engineBrands = [
  {
    name: "",
    image: "/images/spotlock/makoshark.png",
    isAuthorizedDealer: true,
    isAuthorizedService: false,
  },
];

const SpotLockPage: React.FC = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <div className="w-full bg-[#fdfaf6] text-gray-800 font-montserrat">
      {/* Başlık */}
      <section className="text-center py-16 px-6 bg-[#002744] text-white">
        <h1 className="text-4xl md:text-5xl font-bold mb-6 tracking-wide">
          Sanal Çapa - Elektrikli Motor
        </h1>
        <p className="text-lg md:text-xl max-w-3xl mx-auto opacity-90 leading-relaxed">
          Elektrikli Motor ve Sanal Çapa (Spot Lock) sistemiyle sessiz, güvenli
          ve konforlu bir deniz deneyimi sunuyoruz.
        </p>
      </section>

      {/* Elektrikli Motor */}
      <section className="py-16 px-6 bg-white">
        <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              Doğayla Dost, Sessiz ve Güçlü!
            </h2>
            <p className="text-lg text-gray-900 leading-relaxed text-justify whitespace-pre-line">
              Elektrikli motorlar sessiz, çevre dostu ve bakım gereksinimi düşük
              yapısıyla modern denizciliğin yeni standardıdır. Ayvalık Marin
              olarak sunduğumuz çözümler, doğayla uyumlu yapısıyla çevreyi
              korurken, konforlu ve güvenli bir deniz keyfi yaşamanızı sağlar.
            </p>
          </div>
          <div className="flex justify-center">
            <img
              src="/images/spotlock/e-engine.webp"
              alt="Elektrikli motor"
              className="rounded-lg object-cover w-[300px] h-auto"
            />
          </div>
        </div>
      </section>

      {/* Spot Lock */}
      <section className="py-16 px-6 bg-gray-100">
        <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-12 items-center">
          <div className="flex justify-center order-2 md:order-1">
            <img
              src="/images/spotlock/spotlock.webp"
              alt="Sanal Çapa"
              className="rounded-lg object-cover w-[300px] h-auto"
            />
          </div>
          <div className="order-1 md:order-2">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              Rüzgâr Nereden Eserse Essin, Siz Yerinizde Kalın!
            </h2>
            <p className="text-lg text-gray-900 leading-relaxed text-justify whitespace-pre-line">
              Spot Lock (sanal çapa) teknolojisi, GPS destekli sistemiyle
              teknenizi sabit tutarak klasik çapa ihtiyacını ortadan kaldırır.
              Balık tutarken, dalış yaparken ya da sadece manzaranın tadını
              çıkarırken, teknenizin sürüklenmesini düşünmeden denizin keyfini
              çıkarın.
            </p>
          </div>
        </div>
      </section>

      {/* İş Ortakları */}
      <section className="max-w-7xl mx-auto py-20 px-6">
        <h2 className="text-4xl font-bold text-center mb-8">İş Ortaklarımız</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
          {engineBrands.map((brand) => (
            <EngineBrandCard key={brand.name} {...brand} />
          ))}
        </div>
      </section>
    </div>
  );
};

export default SpotLockPage;
